export const PRODUCTION_INSTRUCTION_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: '製造指示',
  // テーブル名
  TARGET_TABLE: 'item_stockinfo',
};
